var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "mb-4" },
    [
      !_vm.abrigedTableMode
        ? _c(
            "v-card",
            [
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ies-green",
                      on: {
                        click: function ($event) {
                          return _vm.saveData()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("save")]), _vm._v(" Save")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "yellow",
                      attrs: { title: "Press 'Esc' to clear date selections" },
                      on: {
                        click: function ($event) {
                          return _vm.unselectDates()
                        },
                      },
                    },
                    [
                      _c("v-icon", [_vm._v("clear")]),
                      _vm._v(" Clear Date Selections"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ies-coral",
                      on: {
                        click: function ($event) {
                          return _vm.undoChanges()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("undo")]), _vm._v(" Undo Changes")],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-4" }, [
                    _vm.isSaving
                      ? _c(
                          "span",
                          [
                            _c("v-icon", { staticClass: "spin" }, [
                              _vm._v("sync"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.saveSuccess
                      ? _c(
                          "span",
                          [
                            _c("v-icon", { attrs: { color: "green" } }, [
                              _vm._v("done"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Changes saved successfully")]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.saveError
                      ? _c(
                          "span",
                          { staticClass: "ies-coral--text" },
                          [
                            _c("v-icon", { attrs: { color: "ies-coral" } }, [
                              _vm._v("error"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "Changes could not be saved: " +
                                  _vm._s(_vm.errorMessage)
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.abrigedTableMode
        ? _c("v-flex", { attrs: { xs12: "" } }, [
            _vm._v(
              "\n            Last updated at: " +
                _vm._s(_vm.lastUpdated.date) +
                " by " +
                _vm._s(_vm.lastUpdated.user) +
                "\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  staticClass:
                    "position-relative overflow-y-auto table-container",
                  staticStyle: { "max-height": "80vh" },
                  attrs: { xs12: "" },
                },
                [
                  _c("table", { staticClass: "daily-planner" }, [
                    _c(
                      "thead",
                      [
                        _c("th", { staticClass: "header-cell" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.getMonthOfYear(_vm.dateFrom.getMonth())
                              ) +
                                " " +
                                _vm._s(_vm.dateFrom.getFullYear()) +
                                " "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.calendarDates, function (day) {
                          return [
                            _c(
                              "th",
                              {
                                class: {
                                  "calendar-date": true,
                                  weekend:
                                    day.dayIndex == 5 || day.dayIndex == 6,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    class: {
                                      "date-out-of-range": _vm.dateIsOutOfRange(
                                        day.date
                                      ),
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "date-text" }, [
                                      _vm._v(_vm._s(day.dayString)),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "date-number" }, [
                                      _vm._v(_vm._s(day.dateOfMonth)),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "date-text" }, [
                                      _vm._v(_vm._s(day.monthString)),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.responseDataReady
                      ? _c(
                          "tbody",
                          [
                            _vm._l(_vm.orderedHotelRooms, function (roomType) {
                              return _vm.selectedRoomTypeKeys.includes(
                                roomType.hotelRoomKey
                              ) || _vm.selectedRoomTypeKeys.length == 0
                                ? [
                                    _c("ies-hotel-planner-availability-row", {
                                      attrs: {
                                        roomType: roomType,
                                        availabilityPerDateSaved:
                                          _vm.localResponseData.tableData
                                            .hotelRooms[roomType.hotelRoomKey]
                                            .availabilityPerDate,
                                        datesWithinRange: _vm.datesWithinRange,
                                        isDisabled: _vm.isDisabled,
                                        selectedAvailabilityDates:
                                          _vm.selectedAvailabilityDates,
                                        availabilityCellDisplay:
                                          _vm.availabilityCellDisplay,
                                        availabilityDateMode:
                                          _vm.availabilityDateMode,
                                        editingAvailabilityDates:
                                          _vm.editingAvailabilityDates,
                                        selectedRoomType: _vm.selectedRoomType,
                                        cellWidthPx: _vm.tableCellWidthPx,
                                      },
                                      on: {
                                        openEditAvailabilityDates:
                                          _vm.handleOpenEditAvailabilityDates,
                                        selectAvailabilityDate:
                                          _vm.handleSelectAvailabilityDate,
                                        "update:availabilityDateMode":
                                          function ($event) {
                                            _vm.availabilityDateMode = $event
                                          },
                                        "update:availability-date-mode":
                                          function ($event) {
                                            _vm.availabilityDateMode = $event
                                          },
                                        "update:editingAvailabilityDates":
                                          function ($event) {
                                            _vm.editingAvailabilityDates =
                                              $event
                                          },
                                        "update:editing-availability-dates":
                                          function ($event) {
                                            _vm.editingAvailabilityDates =
                                              $event
                                          },
                                        "update:selectedRoomType": function (
                                          $event
                                        ) {
                                          _vm.selectedRoomType = $event
                                        },
                                        "update:selected-room-type": function (
                                          $event
                                        ) {
                                          _vm.selectedRoomType = $event
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm._l(
                                      roomType.rateTypes,
                                      function (rateType) {
                                        return !_vm.abrigedTableMode &&
                                          (_vm.selectedRateTypeKeys.includes(
                                            rateType.rateTypeKey
                                          ) ||
                                            _vm.selectedTableViewOptions[
                                              "rateTypeOptions"
                                            ].length == 0)
                                          ? [
                                              _c("ies-hotel-planner-rate-row", {
                                                attrs: {
                                                  rowHeader: rateType.name,
                                                  ratesPerDate:
                                                    rateType.ratesPerDate,
                                                  ratesPerDateSaved:
                                                    _vm.localResponseData
                                                      .tableData.hotelRooms[
                                                      roomType.hotelRoomKey
                                                    ].rateTypes[
                                                      rateType.rateTypeKey
                                                    ].ratesPerDate,
                                                  availabilityPerDateSaved:
                                                    _vm.localResponseData
                                                      .tableData.hotelRooms[
                                                      roomType.hotelRoomKey
                                                    ].availabilityPerDate,
                                                  standardOccupancy:
                                                    roomType.standard_occupancy,
                                                  isDisabled: _vm.isDisabled,
                                                  rateColumn: "rate_standard",
                                                  datesWithinRange:
                                                    _vm.datesWithinRange,
                                                  editingRateDates:
                                                    _vm.editingRateDates,
                                                  selectedRateDates:
                                                    _vm.selectedRateDates,
                                                  rateDateMode:
                                                    _vm.rateDateMode,
                                                  selectedRateColumn:
                                                    _vm.selectedRateColumn,
                                                  cellWidthPx:
                                                    _vm.tableCellWidthPx,
                                                },
                                                on: {
                                                  openEditRateDates:
                                                    _vm.handleOpenEditRateDates,
                                                  selectRateDate:
                                                    _vm.handleSelectRateDate,
                                                  unselectDates:
                                                    _vm.unselectDates,
                                                  "update:rateDateMode":
                                                    function ($event) {
                                                      _vm.rateDateMode = $event
                                                    },
                                                  "update:rate-date-mode":
                                                    function ($event) {
                                                      _vm.rateDateMode = $event
                                                    },
                                                  "update:selectedRateColumn":
                                                    function ($event) {
                                                      _vm.selectedRateColumn =
                                                        $event
                                                    },
                                                  "update:selected-rate-column":
                                                    function ($event) {
                                                      _vm.selectedRateColumn =
                                                        $event
                                                    },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _vm.selectedTableViewOptions[
                                                "showSingleRate"
                                              ] && roomType.single_occupancy
                                                ? _c(
                                                    "ies-hotel-planner-rate-row",
                                                    {
                                                      attrs: {
                                                        rowHeader:
                                                          "Single Rate",
                                                        ratesPerDate:
                                                          rateType.ratesPerDate,
                                                        ratesPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].rateTypes[
                                                            rateType.rateTypeKey
                                                          ].ratesPerDate,
                                                        availabilityPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].availabilityPerDate,
                                                        standardOccupancy:
                                                          roomType.standard_occupancy,
                                                        isDisabled:
                                                          _vm.isDisabled,
                                                        rateColumn:
                                                          "rate_single",
                                                        datesWithinRange:
                                                          _vm.datesWithinRange,
                                                        editingRateDates:
                                                          _vm.editingRateDates,
                                                        selectedRateDates:
                                                          _vm.selectedRateDates,
                                                        rateDateMode:
                                                          _vm.rateDateMode,
                                                        selectedRateColumn:
                                                          _vm.selectedRateColumn,
                                                        cellWidthPx:
                                                          _vm.tableCellWidthPx,
                                                      },
                                                      on: {
                                                        openEditRateDates:
                                                          _vm.handleOpenEditRateDates,
                                                        selectRateDate:
                                                          _vm.handleSelectRateDate,
                                                        unselectDates:
                                                          _vm.unselectDates,
                                                        "update:rateDateMode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:rate-date-mode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:selectedRateColumn":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                        "update:selected-rate-column":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.selectedTableViewOptions[
                                                "showExtraCotRate"
                                              ] &&
                                              !_vm.showUniversalRates &&
                                              roomType.extraBaby
                                                ? _c(
                                                    "ies-hotel-planner-rate-row",
                                                    {
                                                      attrs: {
                                                        rowHeader:
                                                          _vm.extraBabyText,
                                                        ratesPerDate:
                                                          rateType.ratesPerDate,
                                                        ratesPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].rateTypes[
                                                            rateType.rateTypeKey
                                                          ].ratesPerDate,
                                                        availabilityPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].availabilityPerDate,
                                                        standardOccupancy:
                                                          roomType.standard_occupancy,
                                                        isDisabled:
                                                          _vm.isDisabled,
                                                        rateColumn:
                                                          "rate_extra_baby",
                                                        datesWithinRange:
                                                          _vm.datesWithinRange,
                                                        editingRateDates:
                                                          _vm.editingRateDates,
                                                        selectedRateDates:
                                                          _vm.selectedRateDates,
                                                        rateDateMode:
                                                          _vm.rateDateMode,
                                                        selectedRateColumn:
                                                          _vm.selectedRateColumn,
                                                        cellWidthPx:
                                                          _vm.tableCellWidthPx,
                                                      },
                                                      on: {
                                                        openEditRateDates:
                                                          _vm.handleOpenEditRateDates,
                                                        selectRateDate:
                                                          _vm.handleSelectRateDate,
                                                        unselectDates:
                                                          _vm.unselectDates,
                                                        "update:rateDateMode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:rate-date-mode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:selectedRateColumn":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                        "update:selected-rate-column":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.selectedTableViewOptions[
                                                "showExtraChildBedRate"
                                              ] &&
                                              !_vm.showUniversalRates &&
                                              roomType.extraChild
                                                ? _c(
                                                    "ies-hotel-planner-rate-row",
                                                    {
                                                      attrs: {
                                                        rowHeader:
                                                          _vm.extraChildText,
                                                        ratesPerDate:
                                                          rateType.ratesPerDate,
                                                        ratesPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].rateTypes[
                                                            rateType.rateTypeKey
                                                          ].ratesPerDate,
                                                        availabilityPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].availabilityPerDate,
                                                        standardOccupancy:
                                                          roomType.standard_occupancy,
                                                        isDisabled:
                                                          _vm.isDisabled,
                                                        rateColumn:
                                                          "rate_extra_child",
                                                        datesWithinRange:
                                                          _vm.datesWithinRange,
                                                        editingRateDates:
                                                          _vm.editingRateDates,
                                                        selectedRateDates:
                                                          _vm.selectedRateDates,
                                                        rateDateMode:
                                                          _vm.rateDateMode,
                                                        selectedRateColumn:
                                                          _vm.selectedRateColumn,
                                                        cellWidthPx:
                                                          _vm.tableCellWidthPx,
                                                      },
                                                      on: {
                                                        openEditRateDates:
                                                          _vm.handleOpenEditRateDates,
                                                        selectRateDate:
                                                          _vm.handleSelectRateDate,
                                                        unselectDates:
                                                          _vm.unselectDates,
                                                        "update:rateDateMode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:rate-date-mode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:selectedRateColumn":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                        "update:selected-rate-column":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.selectedTableViewOptions[
                                                "showExtraOldChildBedRate"
                                              ] &&
                                              !_vm.showUniversalRates &&
                                              roomType.extraOldChild
                                                ? _c(
                                                    "ies-hotel-planner-rate-row",
                                                    {
                                                      attrs: {
                                                        rowHeader:
                                                          _vm.extraOldChildText,
                                                        ratesPerDate:
                                                          rateType.ratesPerDate,
                                                        ratesPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].rateTypes[
                                                            rateType.rateTypeKey
                                                          ].ratesPerDate,
                                                        availabilityPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].availabilityPerDate,
                                                        standardOccupancy:
                                                          roomType.standard_occupancy,
                                                        isDisabled:
                                                          _vm.isDisabled,
                                                        rateColumn:
                                                          "rate_extra_oldchild",
                                                        datesWithinRange:
                                                          _vm.datesWithinRange,
                                                        editingRateDates:
                                                          _vm.editingRateDates,
                                                        selectedRateDates:
                                                          _vm.selectedRateDates,
                                                        rateDateMode:
                                                          _vm.rateDateMode,
                                                        selectedRateColumn:
                                                          _vm.selectedRateColumn,
                                                        cellWidthPx:
                                                          _vm.tableCellWidthPx,
                                                      },
                                                      on: {
                                                        openEditRateDates:
                                                          _vm.handleOpenEditRateDates,
                                                        selectRateDate:
                                                          _vm.handleSelectRateDate,
                                                        unselectDates:
                                                          _vm.unselectDates,
                                                        "update:rateDateMode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:rate-date-mode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:selectedRateColumn":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                        "update:selected-rate-column":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.selectedTableViewOptions[
                                                "showExtraBedRate"
                                              ] &&
                                              !_vm.showUniversalRates &&
                                              roomType.extraAdult
                                                ? _c(
                                                    "ies-hotel-planner-rate-row",
                                                    {
                                                      attrs: {
                                                        rowHeader:
                                                          _vm.extraAdultText,
                                                        ratesPerDate:
                                                          rateType.ratesPerDate,
                                                        ratesPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].rateTypes[
                                                            rateType.rateTypeKey
                                                          ].ratesPerDate,
                                                        availabilityPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].availabilityPerDate,
                                                        standardOccupancy:
                                                          roomType.standard_occupancy,
                                                        isDisabled:
                                                          _vm.isDisabled,
                                                        rateColumn:
                                                          "rate_extra_adult",
                                                        datesWithinRange:
                                                          _vm.datesWithinRange,
                                                        editingRateDates:
                                                          _vm.editingRateDates,
                                                        selectedRateDates:
                                                          _vm.selectedRateDates,
                                                        rateDateMode:
                                                          _vm.rateDateMode,
                                                        selectedRateColumn:
                                                          _vm.selectedRateColumn,
                                                        cellWidthPx:
                                                          _vm.tableCellWidthPx,
                                                      },
                                                      on: {
                                                        openEditRateDates:
                                                          _vm.handleOpenEditRateDates,
                                                        selectRateDate:
                                                          _vm.handleSelectRateDate,
                                                        unselectDates:
                                                          _vm.unselectDates,
                                                        "update:rateDateMode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:rate-date-mode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:selectedRateColumn":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                        "update:selected-rate-column":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.selectedTableViewOptions[
                                                "showMinimumStay"
                                              ]
                                                ? _c(
                                                    "ies-hotel-planner-rate-row",
                                                    {
                                                      attrs: {
                                                        rowHeader:
                                                          "Minimum Stay",
                                                        ratesPerDate:
                                                          rateType.ratesPerDate,
                                                        ratesPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].rateTypes[
                                                            rateType.rateTypeKey
                                                          ].ratesPerDate,
                                                        availabilityPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].availabilityPerDate,
                                                        standardOccupancy:
                                                          roomType.standard_occupancy,
                                                        isDisabled:
                                                          _vm.isDisabled,
                                                        rateColumn: "min_stay",
                                                        datesWithinRange:
                                                          _vm.datesWithinRange,
                                                        editingRateDates:
                                                          _vm.editingRateDates,
                                                        selectedRateDates:
                                                          _vm.selectedRateDates,
                                                        rateDateMode:
                                                          _vm.rateDateMode,
                                                        selectedRateColumn:
                                                          _vm.selectedRateColumn,
                                                        cellWidthPx:
                                                          _vm.tableCellWidthPx,
                                                      },
                                                      on: {
                                                        openEditRateDates:
                                                          _vm.handleOpenEditRateDates,
                                                        selectRateDate:
                                                          _vm.handleSelectRateDate,
                                                        unselectDates:
                                                          _vm.unselectDates,
                                                        "update:rateDateMode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:rate-date-mode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:selectedRateColumn":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                        "update:selected-rate-column":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.selectedTableViewOptions[
                                                "showMaximumStay"
                                              ]
                                                ? _c(
                                                    "ies-hotel-planner-rate-row",
                                                    {
                                                      attrs: {
                                                        rowHeader:
                                                          "Maximum Stay",
                                                        ratesPerDate:
                                                          rateType.ratesPerDate,
                                                        ratesPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].rateTypes[
                                                            rateType.rateTypeKey
                                                          ].ratesPerDate,
                                                        availabilityPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].availabilityPerDate,
                                                        standardOccupancy:
                                                          roomType.standard_occupancy,
                                                        isDisabled:
                                                          _vm.isDisabled,
                                                        rateColumn: "max_stay",
                                                        datesWithinRange:
                                                          _vm.datesWithinRange,
                                                        editingRateDates:
                                                          _vm.editingRateDates,
                                                        selectedRateDates:
                                                          _vm.selectedRateDates,
                                                        rateDateMode:
                                                          _vm.rateDateMode,
                                                        selectedRateColumn:
                                                          _vm.selectedRateColumn,
                                                        cellWidthPx:
                                                          _vm.tableCellWidthPx,
                                                      },
                                                      on: {
                                                        openEditRateDates:
                                                          _vm.handleOpenEditRateDates,
                                                        selectRateDate:
                                                          _vm.handleSelectRateDate,
                                                        unselectDates:
                                                          _vm.unselectDates,
                                                        "update:rateDateMode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:rate-date-mode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:selectedRateColumn":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                        "update:selected-rate-column":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.selectedTableViewOptions[
                                                "showNoCheckInDays"
                                              ] &&
                                              rateType.is_checkinout_variable
                                                ? _c(
                                                    "ies-hotel-planner-rate-row",
                                                    {
                                                      attrs: {
                                                        rowHeader:
                                                          "No Check In Days",
                                                        ratesPerDate:
                                                          rateType.ratesPerDate,
                                                        ratesPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].rateTypes[
                                                            rateType.rateTypeKey
                                                          ].ratesPerDate,
                                                        availabilityPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].availabilityPerDate,
                                                        standardOccupancy:
                                                          roomType.standard_occupancy,
                                                        isDisabled:
                                                          _vm.isDisabled,
                                                        rateColumn:
                                                          "days_checkin",
                                                        datesWithinRange:
                                                          _vm.datesWithinRange,
                                                        editingRateDates:
                                                          _vm.editingRateDates,
                                                        selectedRateDates:
                                                          _vm.selectedRateDates,
                                                        rateDateMode:
                                                          _vm.rateDateMode,
                                                        selectedRateColumn:
                                                          _vm.selectedRateColumn,
                                                        cellWidthPx:
                                                          _vm.tableCellWidthPx,
                                                      },
                                                      on: {
                                                        openEditRateDates:
                                                          _vm.handleOpenEditRateDates,
                                                        selectRateDate:
                                                          _vm.handleSelectRateDate,
                                                        unselectDates:
                                                          _vm.unselectDates,
                                                        "update:rateDateMode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:rate-date-mode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:selectedRateColumn":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                        "update:selected-rate-column":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.selectedTableViewOptions[
                                                "showNoCheckOutDays"
                                              ] &&
                                              rateType.is_checkinout_variable
                                                ? _c(
                                                    "ies-hotel-planner-rate-row",
                                                    {
                                                      attrs: {
                                                        rowHeader:
                                                          "No Check Out Days",
                                                        ratesPerDate:
                                                          rateType.ratesPerDate,
                                                        ratesPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].rateTypes[
                                                            rateType.rateTypeKey
                                                          ].ratesPerDate,
                                                        availabilityPerDateSaved:
                                                          _vm.localResponseData
                                                            .tableData
                                                            .hotelRooms[
                                                            roomType
                                                              .hotelRoomKey
                                                          ].availabilityPerDate,
                                                        standardOccupancy:
                                                          roomType.standard_occupancy,
                                                        isDisabled:
                                                          _vm.isDisabled,
                                                        rateColumn:
                                                          "days_checkout",
                                                        datesWithinRange:
                                                          _vm.datesWithinRange,
                                                        editingRateDates:
                                                          _vm.editingRateDates,
                                                        selectedRateDates:
                                                          _vm.selectedRateDates,
                                                        rateDateMode:
                                                          _vm.rateDateMode,
                                                        selectedRateColumn:
                                                          _vm.selectedRateColumn,
                                                        cellWidthPx:
                                                          _vm.tableCellWidthPx,
                                                      },
                                                      on: {
                                                        openEditRateDates:
                                                          _vm.handleOpenEditRateDates,
                                                        selectRateDate:
                                                          _vm.handleSelectRateDate,
                                                        unselectDates:
                                                          _vm.unselectDates,
                                                        "update:rateDateMode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:rate-date-mode":
                                                          function ($event) {
                                                            _vm.rateDateMode =
                                                              $event
                                                          },
                                                        "update:selectedRateColumn":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                        "update:selected-rate-column":
                                                          function ($event) {
                                                            _vm.selectedRateColumn =
                                                              $event
                                                          },
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm._e()
                                      }
                                    ),
                                  ]
                                : _vm._e()
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showUniversalRates && !_vm.abrigedTableMode
                      ? _c(
                          "tfoot",
                          {
                            staticClass: "sticky-footer",
                            staticStyle: {
                              position: "sticky",
                              bottom: "-5px",
                              "z-index": "1",
                              "background-color": "white",
                            },
                          },
                          [
                            _c(
                              "tr",
                              {
                                staticClass: "sticky-footer-header",
                                staticStyle: { "background-color": "#d0d0d0" },
                              },
                              [
                                _c("td", [
                                  _vm._v(
                                    "\n                                    Extra Beds / Guests for all room types\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.calendarDates, function (date) {
                                  return [
                                    _c("td", [
                                      _vm._v(
                                        "\n                                         \n                                    "
                                      ),
                                    ]),
                                  ]
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.selectedTableViewOptions["showExtraCotRate"]
                              ? _c("ies-hotel-planner-universal-rate-row", {
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    rowHeader: _vm.extraBabyText,
                                    rowValue: _vm.rateExtraBabyUniversal,
                                    rateColumn: "extra_baby_rate_amount",
                                    datesWithinRange: _vm.datesWithinRange,
                                    calendarDates: _vm.calendarDates,
                                    savedRates:
                                      _vm.localTableData.universalRates,
                                    unsavedRates:
                                      _vm.localResponseData.tableData
                                        .universalRates,
                                    selectedRateColumn: _vm.selectedRateColumn,
                                    openEditUniversalRates:
                                      _vm.openEditUniversalRates,
                                  },
                                  on: {
                                    openEditUniversalRates:
                                      _vm.handleOpenEditUniversalRates,
                                    "update:selectedRateColumn": function (
                                      $event
                                    ) {
                                      _vm.selectedRateColumn = $event
                                    },
                                    "update:selected-rate-column": function (
                                      $event
                                    ) {
                                      _vm.selectedRateColumn = $event
                                    },
                                    "update:openEditUniversalRates": function (
                                      $event
                                    ) {
                                      _vm.openEditUniversalRates = $event
                                    },
                                    "update:open-edit-universal-rates":
                                      function ($event) {
                                        _vm.openEditUniversalRates = $event
                                      },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedTableViewOptions[
                              "showExtraChildBedRate"
                            ]
                              ? _c("ies-hotel-planner-universal-rate-row", {
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    rowHeader: _vm.extraChildText,
                                    rowValue: _vm.rateExtraChildUniversal,
                                    rateColumn: "extra_child_rate_amount",
                                    datesWithinRange: _vm.datesWithinRange,
                                    calendarDates: _vm.calendarDates,
                                    savedRates:
                                      _vm.localTableData.universalRates,
                                    unsavedRates:
                                      _vm.localResponseData.tableData
                                        .universalRates,
                                    selectedRateColumn: _vm.selectedRateColumn,
                                    openEditUniversalRates:
                                      _vm.openEditUniversalRates,
                                  },
                                  on: {
                                    openEditUniversalRates:
                                      _vm.handleOpenEditUniversalRates,
                                    "update:selectedRateColumn": function (
                                      $event
                                    ) {
                                      _vm.selectedRateColumn = $event
                                    },
                                    "update:selected-rate-column": function (
                                      $event
                                    ) {
                                      _vm.selectedRateColumn = $event
                                    },
                                    "update:openEditUniversalRates": function (
                                      $event
                                    ) {
                                      _vm.openEditUniversalRates = $event
                                    },
                                    "update:open-edit-universal-rates":
                                      function ($event) {
                                        _vm.openEditUniversalRates = $event
                                      },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedTableViewOptions[
                              "showExtraOldChildBedRate"
                            ]
                              ? _c("ies-hotel-planner-universal-rate-row", {
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    rowHeader: _vm.extraOldChildText,
                                    rowValue: _vm.rateExtraOldchildUniversal,
                                    rateColumn: "extra_oldchild_rate_amount",
                                    datesWithinRange: _vm.datesWithinRange,
                                    calendarDates: _vm.calendarDates,
                                    savedRates:
                                      _vm.localTableData.universalRates,
                                    unsavedRates:
                                      _vm.localResponseData.tableData
                                        .universalRates,
                                    selectedRateColumn: _vm.selectedRateColumn,
                                    openEditUniversalRates:
                                      _vm.openEditUniversalRates,
                                  },
                                  on: {
                                    openEditUniversalRates:
                                      _vm.handleOpenEditUniversalRates,
                                    "update:selectedRateColumn": function (
                                      $event
                                    ) {
                                      _vm.selectedRateColumn = $event
                                    },
                                    "update:selected-rate-column": function (
                                      $event
                                    ) {
                                      _vm.selectedRateColumn = $event
                                    },
                                    "update:openEditUniversalRates": function (
                                      $event
                                    ) {
                                      _vm.openEditUniversalRates = $event
                                    },
                                    "update:open-edit-universal-rates":
                                      function ($event) {
                                        _vm.openEditUniversalRates = $event
                                      },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedTableViewOptions["showExtraBedRate"]
                              ? _c("ies-hotel-planner-universal-rate-row", {
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    rowHeader: _vm.extraAdultText,
                                    rowValue: _vm.rateExtraAdultUniversal,
                                    rateColumn: "extra_adult_rate_amount",
                                    datesWithinRange: _vm.datesWithinRange,
                                    calendarDates: _vm.calendarDates,
                                    savedRates:
                                      _vm.localTableData.universalRates,
                                    unsavedRates:
                                      _vm.localResponseData.tableData
                                        .universalRates,
                                    selectedRateColumn: _vm.selectedRateColumn,
                                    openEditUniversalRates:
                                      _vm.openEditUniversalRates,
                                  },
                                  on: {
                                    openEditUniversalRates:
                                      _vm.handleOpenEditUniversalRates,
                                    "update:selectedRateColumn": function (
                                      $event
                                    ) {
                                      _vm.selectedRateColumn = $event
                                    },
                                    "update:selected-rate-column": function (
                                      $event
                                    ) {
                                      _vm.selectedRateColumn = $event
                                    },
                                    "update:openEditUniversalRates": function (
                                      $event
                                    ) {
                                      _vm.openEditUniversalRates = $event
                                    },
                                    "update:open-edit-universal-rates":
                                      function ($event) {
                                        _vm.openEditUniversalRates = $event
                                      },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showEditForm
            ? _c("ies-hotel-planner-edit-form", {
                attrs: {
                  selectedRoomType: _vm.selectedRoomType,
                  selectedRateColumn: _vm.selectedRateColumn,
                  currencyCode: _vm.currencycode,
                  selectedRateDates: _vm.selectedRateDates,
                  selectedAvailabilityDates: _vm.selectedAvailabilityDates,
                  openEditAvailabilityDates: _vm.openEditAvailabilityDates,
                  openEditRateDates: _vm.openEditRateDates,
                  openEditUniversalRates: _vm.openEditUniversalRates,
                  localTableData: _vm.localTableData,
                },
                on: {
                  closeEditForm: _vm.handleCloseEditForm,
                  unselectDates: _vm.unselectDates,
                  "update:localTableData": function ($event) {
                    _vm.localTableData = $event
                  },
                  "update:local-table-data": function ($event) {
                    _vm.localTableData = $event
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.abrigedTableMode
        ? _c(
            "v-card",
            [
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ies-green",
                      on: {
                        click: function ($event) {
                          return _vm.saveData()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("save")]), _vm._v(" Save")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "yellow",
                      attrs: { title: "Press 'Esc' to clear date selections" },
                      on: {
                        click: function ($event) {
                          return _vm.unselectDates()
                        },
                      },
                    },
                    [
                      _c("v-icon", [_vm._v("clear")]),
                      _vm._v(" Clear Date Selections"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ies-coral",
                      on: {
                        click: function ($event) {
                          return _vm.undoChanges()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("undo")]), _vm._v(" Undo Changes")],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-4" }, [
                    _vm.isSaving
                      ? _c(
                          "span",
                          [
                            _c("v-icon", { staticClass: "spin" }, [
                              _vm._v("sync"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.saveSuccess
                      ? _c(
                          "span",
                          [
                            _c("v-icon", { attrs: { color: "green" } }, [
                              _vm._v("done"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Changes saved successfully")]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.saveError
                      ? _c(
                          "span",
                          { staticClass: "ies-coral--text" },
                          [
                            _c("v-icon", { attrs: { color: "ies-coral" } }, [
                              _vm._v("error"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "Changes could not be saved: " +
                                  _vm._s(_vm.errorMessage)
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }